import Grid2 from "@mui/material/Unstable_Grid2";
import CommodityForm1 from "./CommodityForm1";
import CommodityForm2 from "./CommodityForm2";
import { useDomesticMarketSpreadPriceContext } from "../../../../../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceContext";
import { useDomesticMarketSpreadPriceProducerContext } from "../../../../../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceProducerContext";
import useResponsive from "../../../../../components/hooks/useResponsive";
import AddToFavoritesButton from "../../../../../components/favorite/AddToFavoritesButton";
import { BarChartOutlined } from "@mui/icons-material";
import Loading from "../../../../../components/loader/Loading";
import { sendData } from "../../../../../lib/dashboard/actions";
import { mutate } from "swr";

const ProducerForm = () => {
  const { isMd } = useResponsive();

  const { isFavoritesValidation } = useDomesticMarketSpreadPriceContext();

  const {
    inputProducerValues1,
    inputProducerValues2,
    handleShowChart,
    isChartLoading,
  } = useDomesticMarketSpreadPriceProducerContext();

  const body = {
    company1_id: inputProducerValues1.company?.id,
    group1_id: inputProducerValues1.group?.id,
    commodity1_id: inputProducerValues1.commodity?.id,
    company2_id: inputProducerValues2.company?.id,
    group2_id: inputProducerValues2.group?.id,
    commodity2_id: inputProducerValues2.commodity?.id,
  };
  const handleAddToFavorite = async () => {
    const res = await sendData(body, "/favorite/domestic-ratio/producer");
    if (res.status === 200) await mutate("/favorite/domestic-ratio/producer");
  };

  const isDisabled = [
    inputProducerValues1.company?.id,
    inputProducerValues1.group?.id,
    inputProducerValues2.company?.id,
    inputProducerValues2.group?.id,
  ].every(Boolean);

  return (
    <Grid2 container spacing={2}>
      <Grid2 xs={12}>
        <CommodityForm1 />
      </Grid2>
      <Grid2 xs={12}>
        <CommodityForm2 />
      </Grid2>
      <Grid2 xs={10} md={6}>
        <button
          style={{ height: "43px" }}
          onClick={() => handleShowChart(body)}
          className={`btn ${!isDisabled ? " btn-softblue" : "btn-blue"}`}
          disabled={!isDisabled || isChartLoading}
        >
          {isChartLoading ? (
            <Loading color={"#fff"} />
          ) : (
            <>
              نمایش
              <BarChartOutlined />
            </>
          )}
        </button>
      </Grid2>
      <Grid2 xs={2} md={6}>
        <AddToFavoritesButton
          text={isMd && "افزودن به علاقمندی ها"}
          style={{ height: "44px" }}
          isDisabled={!isDisabled}
          onClick={handleAddToFavorite}
          isLoading={isFavoritesValidation}
        />
      </Grid2>
    </Grid2>
  );
};

export default ProducerForm;
